// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/line
import { ResponsiveLine } from '@nivo/line';
import React from 'react';
import moment from 'moment-jalaali';
import { convertDigitToEnglish } from '../../../../../../method/convertDigitToEnglish';
import { makeStyles } from '@material-ui/core';
import { handleNumber } from '../../../../../../method/displayData';

const useStyles = makeStyles((theme) => ({
  tooltip: {
    background: "#fff",
    padding: 10,
    border: "0.5px solid #555",
    borderRadius: 5,
    boxShadow: "0px 0px 2px #000",
    direction: "rtl",
    textAlign: "left",
    minWidth: "310px",
  },
  tooltipTitle: {
    fontWeight: 'bold',
    // "inline-block font-bold"
  },
  grid: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    width: '100%',
    margin: '5px 0px'
    // grid grid-cols-12 gap3 w-full
  },
  charts: {
    minWidth: '550px !important'
  },
  gridChart: {
    height: 600,
    minWidth: '550px !important'
  },
  gridBadg:{
    width:'45%',
    padding:'5px 10px',
    borderRadius:27,
    // backgroundColor:'#D9D9D9',
    display:'flex',
    alignItems:'center',
    // justifyContent:'center',
    minWidth:100,
    margin:2.5
  },
  circle:{
    width:15,
    height:15,
    borderRadius:'50%',
    marginRight:5
  },
  gridCard:{
    display:'flex',
    justifyContent:'flax-start',
    marginTop:10,
    flexWrap:'wrap'
  }
}));


const MyResponsiveLine = ({ data, usedColors }) => {

  const classes = useStyles();

  const formatDate = (dateString) => {
    const originalDate = new Date(dateString);
    const formattedDate = moment(originalDate).format('YYYY/MM/DD');
    return convertDigitToEnglish(formattedDate)
  };

  const tooltipBody = (d) => {

    const originalDate = new Date(d.point.data.x);
    const formattedDate = moment(originalDate).format('YYYY/MM/DD');
    return (
      <div className={`${classes.tooltip}`} style={tooltipStyle(d)} >
        <div className={classes['tooltipTitle']}>{d.point.serieId}</div>
        <div className={classes['grid']}>
          <div>{` ${convertDigitToEnglish(formattedDate)} `}</div>
          <div> : تاریخ</div>
        </div>
        <div className={classes['grid']}>
          <div >{` ${handleNumber(d.point.data.y)} `}</div>
          <div > : مقدار </div>
        </div>
      </div>
    );
  };

  const tooltipStyle = (d) => {
    let x = 150;
    let y = 0;

    if (d.point.x > 120) {
      x = 10;
    }
    if (d.point.x > 260) {
      x = -155;
    }

    if (d.point.y < 120) {
      y = 120;
    }

    return { transform: `translate(${x}px,${y}px)`};
  };


  return (
    <div
      className={classes['charts']}
    >
      <div className={classes['gridChart']}>
        <ResponsiveLine
          enableGridX={true}
          enableGridY={true}
          enableArea={true}
          tooltip={(d) => tooltipBody(d)}
          colors={(data) => data?.color}
          curve="monotoneX"
          xFormat='time:%YYYY/%MM/%DD'
          xScale={{
            format: '%YYYY/%MM/%DD',
            precision: 'day',
            type: 'time',
            useUTC: false
          }}
          data={data}
          margin={{ top: 50, right: 110, bottom: 70, left: 60 }}
          yScale={{
            type: 'linear',
          }}
          // yFormat=" >-.2f"
          axisTop={null}
          axisRight={null}
          axisBottom={{
            orient: "bottom",
            tickSize: 5,
            tickPadding: 60,
            tickRotation: -90,
            legend: "",
            legendOffset: 36,
            format: (dateString) => formatDate(dateString),
          }}
          axisLeft={{
            // tickSize: 5,
            tickPadding: 40,
            tickRotation: 0,
            legend: '',
            legendOffset: -150,
            legendPosition: 'middle'
          }}
          pointSize={10}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabelYOffset={-12}
          useMesh={true}
          legends={[]}
          // legends={[
          //   {
          //     anchor: 'top-right',
          //     direction: 'column',
          //     // direction: 'row',
          //     justify: true,
          //     translateX: 100,
          //     translateY: -30,
          //     itemsSpacing: 0,
          //     // itemDirection: 'left-to-right',
          //     itemDirection: 'right-to-left',
          //     itemWidth: 15,
          //     itemHeight: 25,
          //     itemOpacity: 1,
          //     symbolSize: 12,
          //     symbolShape: 'circle',
          //     symbolBorderColor: 'rgba(0, 0, 0, .5)',
          //     effects: [
          //       {
          //         on: 'hover',
          //         style: {
          //           itemBackground: 'rgba(0, 0, 0, .03)',
          //           itemOpacity: 1
          //         }
          //       }
          //     ]
          //   }
          // ]}
        />
      </div>

<div className={classes['gridCard']}>

      {
        Object.keys(usedColors)?.map((item) => {
          return (
            <div className={classes['gridBadg']}>
              <div className={classes['circle']} style={{backgroundColor:usedColors?.[item]?.color ?usedColors?.[item]?.color :'red'}}></div>
              {usedColors?.[item]?.name}
            </div>
          )
        })
      }
</div>

    
    </div>
  )
}

export default MyResponsiveLine